/*
 * gamepick.js -- stitkovy vicenasobny vyber her v poptavkovem formulari.
 *
 * PROC TENHLE MODUL VZNIKL (regrese nahlasena majitelem 8. 9. 2026)
 *
 * Doslova: "Vyber her ve formulari ma byt multiselect. Mam mit moznost
 * vybrat nekolik her soucasne s tim, ze pokud posilam poptavku z Treasure
 * Hunt Praha, tak mam mit ve formulari predvybrane Treasure Hunt Praha --
 * uz to tam bylo, ale nekdo to prepsal na single select."
 *
 * Zivy web to opravdu umi: `wp-content-theme/terrahunt/template-parts/
 * form-game-outdoor.php:204` vykresluje `<select multiple="multiple">`
 * a jeho `assets/js/main.js` v nem predvybere hru podle `<h1>` stranky.
 * Sablona 2026 mezitim vykreslovala `<select name="th_games[]">` BEZ
 * `multiple` a komentar u nej sliboval "skript F1b", ktery nikdy nevznikl
 * (`grep -rn gadd assets/js/src` = 0 nalezu). Tenhle modul je ta chybejici
 * polovina: FUNKCE prenesena 1:1 ze ziveho webu, DESIGN podle navrhu
 * (`navrh-th-lokality.html` ř. 1371-1373 markup, ř. 1565-1590 chovani).
 *
 * CO PRESNE DELA
 *
 * Bez nej zustane v markupu nativni `<select multiple>` s predvybranou
 * hrou detailu -- formular tedy funguje uplne stejne jako zivy web, jen
 * bez pohodli (Ctrl/Cmd + klik). Kdyz modul nabehne, prevede ten samy
 * `<select>` na "picker": vyber prida STITEK a skryte pole `th_games[]`,
 * `<select>` se vrati na uvodni polozku a vybrana hra ze seznamu zmizi
 * (nelze ji pridat dvakrat). Krizek u stitku hru odebere.
 *
 * PROC SE `<select>` PRI PREVODU ZBAVUJE ATRIBUTU `name`
 *
 * Hodnoty od te chvile nese SKRYTE POLE uvnitr stitku. Kdyby `<select>`
 * jmeno atributu ponechal, odeslal by NAVIC svou vlastni aktualni hodnotu
 * -- tedy prazdnou polozku, nebo (kdyby uzivatel neco vybral a formular
 * odeslal drive, nez se prekresli) i hru, kterou uz ma stitek. Prvek bez
 * `name` neni "successful control" a do POSTu se nedostane vubec.
 *
 * ROZSIRENI O OUTDOOR AKTIVITY (druha regrese z 8. 9.)
 *
 * Majitel doslova: "Polozka Chci rozsirit o outdoor aktivity ma byt jen
 * u her, kde je to povoleno v administraci ... Ty jsi to narval vsude."
 * Kazda `<option>` proto nese `data-outdoor="1|0"` (meta
 * `terrahunt_game_outdoor_upsell`, jediny zdroj pravdy
 * `terrahunt_game_shows_outdoor_upsell()`), a souhlas
 * `[data-formsec-addon="outdoor"]` je videt PRAVE TEHDY, kdyz je vybrana
 * aspon jedna hra s jednickou. Pri odebrani posledni takove hry se souhlas
 * schova A ODSKRTNE -- schovane zaskrtnute policko by jinak odeslalo
 * souhlas, ktery uzivatel uz nevidi.
 *
 * JEN VENKU (druhe zuzeni, majitel 9. 9. 2026)
 *
 * Doslova: "u pribehovych her se ma moznost Chci rozsirit o outdoor
 * aktivity (pokud je v administraci zapnuta -- coz je) zobrazit ve
 * frontendu jen tehdy, kdyz je zaskrtnuta Outdoor verze (Indoor a Online
 * nedava smysl)." Souhlas je tedy videt PRAVE TEHDY, kdyz plati OBOJI:
 * aspon jedna vybrana hra ma volbu zapnutou v administraci A v prepinaci
 * "Kde chcete hrat" je zvolene VENKU. Pri "Uvnitr", "Online" i bez volby
 * se souhlas schova A ODSKRTNE. Formulare bez prepinace (venkovni hry)
 * to nijak nemeni -- tam se rozhoduje dal jen podle her.
 *
 * Zavazne je to stejne jako u validace az na SERVERU
 * (`class-form-handler.php`): ten hodnotu zahodi, kdyz ji nema podlozenou
 * ani jedna odeslana hra a kdyz se u pribehovky nehraje venku. Tenhle
 * modul je pohodli, ne pojistka.
 *
 * SKRYVA SE TRIDOU, NE ATRIBUTEM `hidden`. Pravidlo
 * `html.js .formsec [data-formsec-addon]:not(.is-open)` v `components.css`
 * plati jen tam, kde bezi JavaScript; s atributem `hidden` by byl souhlas
 * bez JS nedosazitelny navzdy (kontrakt B).
 *
 * BEZPECNOST: zadny `innerHTML`, zadny `eval`, zadna interpolace vstupu.
 * Stitek se sklada pres `createElement`/`createTextNode` a krizek pres
 * `createElementNS` -- nazev hry i popis pro ctecku jdou do TEXTOVEHO uzlu
 * a do atributu, nikdy do parsovaneho HTML.
 */

/* Trida, kterou se souhlas odkryva -- tataz, jakou zna `components.css`. */
const OPEN = 'is-open';

const ADDON = '[data-formsec-addon="outdoor"]';

const SVG_NS = 'http://www.w3.org/2000/svg';

/*
 * v1.27.17: ktera varianta lamani dlouheho nazvu hry ve stitku se pouzije
 * (`components.css` `.gchip--ellipsis` / `.gchip--wrap`). Prepnuti bez
 * dalsiho vydani = zmena jen tady.
 */
const GCHIP_VARIANT = 'wrap';

/**
 * Krizek do odebiraciho tlacitka (mockup ř. 1578).
 *
 * @return {Element} `<svg>` s dvema tahy.
 */
function crossIcon() {
	const svg = document.createElementNS(SVG_NS, 'svg');

	svg.setAttribute('viewBox', '0 0 10 10');
	svg.setAttribute('width', '9');
	svg.setAttribute('height', '9');
	svg.setAttribute('fill', 'none');
	svg.setAttribute('stroke', 'currentColor');
	svg.setAttribute('stroke-width', '1.8');
	svg.setAttribute('stroke-linecap', 'round');
	svg.setAttribute('aria-hidden', 'true');
	svg.setAttribute('focusable', 'false');

	const path = document.createElementNS(SVG_NS, 'path');

	path.setAttribute('d', 'M1 1l8 8M9 1L1 9');
	svg.appendChild(path);

	return svg;
}

/**
 * Dosadi nazev hry do sablony popisu z registru Textu webu.
 *
 * Kdyz sablona `%s` nema (editor ho smazal), pripoji se nazev za ni --
 * popis tim neztrati smysl a tlacitko nezustane bez pristupneho jmena.
 *
 * @param {string} template Sablona, napr. `Odebrat hru %s`.
 * @param {string} label    Nazev hry.
 * @return {string}
 */
function removeLabel(template, label) {
	if (template === '') {
		return label;
	}

	if (template.indexOf('%s') === -1) {
		return template + ' ' + label;
	}

	return template.replace('%s', label);
}

/**
 * Napoji picker na jeden vyber her.
 *
 * @param {Element} box Kontejner `.gamepick`.
 * @return {void}
 */
function initBox(box) {
	const select = box.querySelector('select.gadd');

	if (!select) {
		return;
	}

	/*
	 * Jmeno pole se cte z markupu, ne zapisuje natvrdo: kontrakt na nazvy
	 * `th_*` drzi `formsec.php` a jeho pripadna zmena se nema resit na
	 * dvou mistech (docblock te komponenty to rika vyslovne).
	 */
	const field = select.getAttribute('name') || 'th_games[]';
	const form = select.form || box.closest('form');
	const chipRemove = String(box.getAttribute('data-th-chip-remove') || '').trim();

	/* Vybrane hry v poradi, v jakem je uzivatel pridal. */
	const chosen = [];

	for (let i = 0; i < select.options.length; i += 1) {
		const option = select.options[i];

		if (option.value !== '' && option.selected) {
			chosen.push(option.value);
		}
	}

	/*
	 * PREVOD NA PICKER. `multiple` musi zmizet driv, nez se sahne na
	 * `value`: u vicenasobneho vyberu je `select.value` jen prvni vybrana
	 * polozka a prirazeni prazdneho retezce by neodznacilo zbytek.
	 */
	select.removeAttribute('multiple');
	select.removeAttribute('name');

	/**
	 * Polozka seznamu podle hodnoty.
	 *
	 * @param {string} value Hodnota `<option>` (ID hry).
	 * @return {Element|null}
	 */
	function optionFor(value) {
		for (let i = 0; i < select.options.length; i += 1) {
			if (select.options[i].value === value) {
				return select.options[i];
			}
		}

		return null;
	}

	/**
	 * Nabizi nektera z vybranych her rozsireni o outdoor aktivity?
	 *
	 * @return {boolean}
	 */
	function anyOutdoor() {
		for (let i = 0; i < chosen.length; i += 1) {
			const option = optionFor(chosen[i]);

			if (option && option.getAttribute('data-outdoor') === '1') {
				return true;
			}
		}

		return false;
	}

	/**
	 * Hraje se VENKU? (rozhodnuti majitele 9. 9. 2026)
	 *
	 * Doslova: "u pribehovych her se ma moznost Chci rozsirit o outdoor
	 * aktivity (pokud je v administraci zapnuta -- coz je) zobrazit ve
	 * frontendu jen tehdy, kdyz je zaskrtnuta Outdoor verze (Indoor
	 * a Online nedava smysl)."
	 *
	 * FORMULAR BEZ PREPINACE MISTA VRACI `true`. Prepinac
	 * venku/uvnitr/online ma JEN podvarianta `escape` (pribehove hry,
	 * `formsec.php` -- `'escape' === $terrahunt_fs_detail`). U venkovnich
	 * her (`game_gps`, podvarianta `outdoor`) zadny neni, a tam se tedy
	 * o viditelnosti souhlasu rozhoduje dal jen podle vybranych her --
	 * presne jako do teto zmeny.
	 *
	 * NEZVOLENO = `false`. Vychozi stav formulare je BEZ vybrane pilulky
	 * (zmereno 9. 9. na detailu hry 974: zadne z tri radii nema `checked`),
	 * takze souhlas je po nacteni zavreny a otevre ho teprve volba "Venku".
	 *
	 * @return {boolean}
	 */
	function whereOutdoor() {
		if (!form) {
			return true;
		}

		const radios = form.querySelectorAll('input[name="th_where"]');

		if (!radios.length) {
			return true;
		}

		for (let i = 0; i < radios.length; i += 1) {
			if (radios[i].checked) {
				return radios[i].value === 'outdoor';
			}
		}

		return false;
	}

	/**
	 * Srovna viditelnost souhlasu s vybranymi hrami A volbou mista.
	 *
	 * @return {void}
	 */
	function syncAddon() {
		if (!form) {
			return;
		}

		const addon = form.querySelector(ADDON);

		if (!addon) {
			return;
		}

		if (anyOutdoor() && whereOutdoor()) {
			addon.classList.add(OPEN);

			return;
		}

		addon.classList.remove(OPEN);

		const checkbox = addon.querySelector('input[type="checkbox"]');

		if (checkbox) {
			checkbox.checked = false;
		}
	}

	/**
	 * Jeden stitek vcetne skryteho pole a odebiraciho tlacitka.
	 *
	 * @param {string} value Hodnota `<option>` (ID hry).
	 * @param {string} label Nazev hry.
	 * @return {Element}
	 */
	function makeChip(value, label) {
		const chip = document.createElement('span');

		chip.className = `gchip gchip--${GCHIP_VARIANT}`;

		/*
		 * Nazev je vlastni <span>, ne holy textovy uzel -- `components.css`
		 * (`.gchip--ellipsis`/`.gchip--wrap` `.gchip__label`) na nej potrebuje
		 * cilit `max-width`/`text-overflow`/`overflow-wrap`, coz na text uzel
		 * napojit nejde. Vizualne beze zmeny: `.gchip` je flex kontejner, ktery
		 * by z holeho textu i tak udelal anonymni flex polozku se stejnym
		 * chovanim jako tenhle pojmenovany <span>.
		 */
		const chipLabel = document.createElement('span');

		chipLabel.className = 'gchip__label';
		chipLabel.appendChild(document.createTextNode(label));
		chip.appendChild(chipLabel);

		const hidden = document.createElement('input');

		hidden.type = 'hidden';
		hidden.name = field;
		hidden.value = value;
		chip.appendChild(hidden);

		const button = document.createElement('button');

		button.type = 'button';
		button.setAttribute('aria-label', removeLabel(chipRemove, label));

		/*
		 * Kolecko kolem krizku je `<span>`, protoze presne na nej mira
		 * `components.css` (`.gchip button span`): klikaci cil ma 44 px,
		 * viditelne kolecko 20 px.
		 */
		const ring = document.createElement('span');

		ring.appendChild(crossIcon());
		button.appendChild(ring);

		button.addEventListener('click', function () {
			const at = chosen.indexOf(value);

			if (at > -1) {
				chosen.splice(at, 1);
			}

			render();
		});

		chip.appendChild(button);

		return chip;
	}

	/**
	 * Prekresli stitky, seznam i souhlas podle stavu.
	 *
	 * @return {void}
	 */
	function render() {
		const old = box.querySelectorAll('.gchip');

		for (let i = 0; i < old.length; i += 1) {
			if (old[i].parentNode) {
				old[i].parentNode.removeChild(old[i]);
			}
		}

		for (let i = 0; i < chosen.length; i += 1) {
			const option = optionFor(chosen[i]);

			if (!option) {
				continue;
			}

			/*
			 * Stitky jsou PRIMI POTOMCI `.gamepick` pred `<select>`.
			 * Mockup mel vnitrni obal `<span class="gchips">` s
			 * `display: contents`, ktery Safari 14-16 vyrazuje z
			 * pristupnostniho stromu (mimo matici podpory) -- viz
			 * komentar u markupu ve `formsec.php`.
			 */
			box.insertBefore(makeChip(option.value, option.text), select);
		}

		for (let i = 0; i < select.options.length; i += 1) {
			const option = select.options[i];

			if (option.value !== '') {
				option.hidden = chosen.indexOf(option.value) > -1;
			}
		}

		select.value = '';
		syncAddon();
	}

	select.addEventListener('change', function () {
		const value = select.value;

		if (value !== '' && chosen.indexOf(value) === -1) {
			chosen.push(value);
		}

		render();
	});

	/*
	 * VOLBA MISTA SE POSLOUCHA DELEGOVANE NA FORMULARI, ne na jednotlivych
	 * radiich: `change` z radia bubla, takze jeden listener staci pro vsechny
	 * tri pilulky a nemusi se prepojovat, kdyby se markup prepocital.
	 */
	if (form) {
		form.addEventListener('change', function (event) {
			const target = event.target;

			if (target && target.name === 'th_where') {
				syncAddon();
			}
		});
	}

	/*
	 * SROVNANI STAVU PRI STARTU dela `render()` svym zavercem -- vola
	 * `syncAddon()` VZDY, i kdyz server vykreslil `is-open`. Bez toho by
	 * na strance z cache zustal souhlas otevreny navzdory tomu, ze zadne
	 * misto neni zvolene.
	 */
	render();
}

/**
 * Inicializace modulu.
 *
 * @return {void}
 */
export function init() {
	const boxes = document.querySelectorAll('.gamepick');

	if (!boxes.length) {
		return;
	}

	for (let i = 0; i < boxes.length; i += 1) {
		initBox(boxes[i]);
	}
}
